import { hostsMayFold, resolveZoneIdViaAliases, ZONE_PROTOCOL_RANK } from '../handlers/zoneDeduplication';
import type { ZoneRow } from './zoneUsbDacRemap';

const ZONE_TYPE_PRIORITY: Record<string, number> = { browser: 100, ...ZONE_PROTOCOL_RANK };

export function findPreferredZone(
  zoneOrId: string,
  zones: ZoneRow[],
  aliases: Record<string, string> = {},
): ZoneRow | null {
  if (!zoneOrId || !zones.length) return null;
  const resolvedId = resolveZoneIdViaAliases(zoneOrId, aliases);
  const selected = zones.find((z) => z.id === resolvedId || z.id === zoneOrId) || null;
  if (!selected) return null;

  let best = selected;
  for (const candidate of zones) {
    const sameHost = hostsMayFold(selected.host, candidate.host);
    const sameName = selected.name?.toLowerCase() === candidate.name?.toLowerCase();
    const exactId = candidate.id === selected.id;
    if (!sameHost && !sameName && !exactId) continue;

    const candidatePriority = ZONE_TYPE_PRIORITY[candidate.type || ''] ?? 0;
    const bestPriority = ZONE_TYPE_PRIORITY[best.type || ''] ?? 0;
    if (candidatePriority > bestPriority) best = candidate;
  }
  return best;
}
